import { render, staticRenderFns } from "./ElPick.vue?vue&type=template&id=3548861e&scoped=true"
import script from "./ElPick.vue?vue&type=script&lang=js"
export * from "./ElPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548861e",
  null
  
)

export default component.exports